import "./loaders/collapse";

/**
 * At click, scroll to element
 * 
 * @param {click} event 
 */
const customScrollTo = (event) => {
    event.preventDefault();
    let targetId = event.target.getAttribute('href');
    if (targetId.charAt(0) === '#') {
        targetId = targetId.substring(1);
    }
    const target = document.getElementById(targetId);

    if (target) {
        const y = target.getBoundingClientRect().top + window.scrollY - 120;

        window.scrollTo({ top: y, behavior: 'smooth' });
    }
    let btn = document.querySelector('.toggle-toc');
    if (btn) {
        btn.click();
    }
}


/**
 * Listen for scroll event and highlight the current section in the table of contents
 *
 */
const listenForScroll = () => {
    if (window.innerWidth >= 992) {
        const anchors = document.querySelectorAll('#table-of-contents a');
        const breakpoint = window.innerHeight / 2;

        for (let i = 0; i < anchors.length; i++) {
            const anchor = anchors[i];
            const targetId = anchor.getAttribute('href').substring(1);
            const target = document.getElementById(targetId);

            if (target) {
                const rect = target.getBoundingClientRect();

                if (rect.top > 115 && rect.top < breakpoint) {
                    if (currentToc) {
                        currentToc.classList.remove('current-toc');
                    }
                    anchor.classList.add('current-toc');
                    currentToc = anchor;
                    break;
                }
            }
        }
    }
};

/**
 * 
 * @param {String} element 
 * @param {String[]} classNames 
 * @returns Element with or without classes 
 */
const createElementWithClass = (element, classNames) => {
    const div = document.createElement(element);
    classNames.forEach(className => {
        if (className) {
            div.classList.add(className);
        }
    });
    return div;
};

/**
 * Exclude unwanted headings
 * any heading that is a child of the following classes will be excluded
 * 
 * @param {NodeList} headings 
 * @returns Filtered headings
 */
const excludeUnwantedHeadings = (headings) => {
    if (!headings || headings.length === 0) {
        return [];
    }

    const unwantedSections = ['.video-block-item', '.accordion-container', '.linkedcontentbannerblock'];
    const inUnwantedSection = (heading) => {
        return unwantedSections.some(section => heading.closest(section));
    };

    return Array.from(headings).filter(heading => {
        return !inUnwantedSection(heading) && window.getComputedStyle(heading).display !== 'none';
    });
};

/**
 * Table of contents
 * 
 * Will be a dropdown on small screens (< 992) and a sidebar on larger screens (>= 992)
 */
let currentToc = document.querySelector('.current-toc');
const useH2 = true;
const useH3 = false;
const lang = document.documentElement.lang === 'en' ? 'en' : 'sv';
const labelSv = 'Hitta';
const labelEn = 'Find';
const srOnlySv = 'på sidan';
const srOnlyEn = 'on page';
const labelLargeSv = 'Innehåll på sidan';
const labelLargeEn = 'Table of contents';
const closeLabelSv = 'Stäng';
const closeLabelEn = 'Close';


// Target and create links for h2 and or h3 elements
const targetHeadings = `${useH2 ? 'h2' : ''}${useH2 && useH3 ? ', ' : ''}${useH3 ? 'h3' : ''}`;
const mainContent = document.querySelector('#maincontent');

if (useH2 || useH3 && mainContent) {
    let headings = mainContent.querySelectorAll(targetHeadings);
    headings = excludeUnwantedHeadings(headings);

    if (headings.length > 0) {
        // Create elements for the table of contents
        const container = createElementWithClass('div', ['container', 'table-of-contents-wrapper']);

        // Toggle button
        const toggleButton = createElementWithClass('button', ['toggle-toc']);
        toggleButton.innerHTML = `<span aria-hidden="true" class="material-icons toc-open">toc</span><span aria-hidden="true" class="material-icons toc-close">close</span><span class="toc-label-open">${lang === 'sv' ? labelSv : labelEn}<span class="sr-only">${lang === 'sv' ? srOnlySv : srOnlyEn}</span></span><span class="toc-label-close">${lang === 'sv' ? closeLabelSv : closeLabelEn}</span>`;
        toggleButton.setAttribute('aria-expanded', 'true');
        toggleButton.setAttribute('aria-controls', 'table-of-contents');
        toggleButton.dataset.toggle = 'collapse';
        toggleButton.dataset.target = '#table-of-contents';

        container.appendChild(toggleButton);

        // Table of contents container
        const toc = createElementWithClass('div', ['table-of-contents-container', 'collapse', 'show']);
        toc.id = 'table-of-contents';

        const divRow = createElementWithClass('div', ['row']);
        const divCol = createElementWithClass('div', ['col-md-10', 'offset-md-1', 'col-lg-8', 'offset-lg-2']);

        const nav = createElementWithClass('nav', []);
        nav.setAttribute('aria-label', lang === 'sv' ? labelLargeSv : labelLargeEn);
        const tocList = createElementWithClass('ul', []);
        divCol.innerHTML = `<h2>${lang === 'sv' ? labelLargeSv : labelLargeEn}</h2>`;


        // Append elements to each parent
        nav.appendChild(tocList);
        divCol.appendChild(nav);
        divRow.appendChild(divCol);
        toc.appendChild(divRow);
        container.appendChild(toc);

        let onlyEmptyHeadings = true;

        // Loop through each heading and create a list item and a link for each
        headings.forEach((heading, index) => {
            if (heading.textContent.trim() !== '') {
                onlyEmptyHeadings = false;
                if (heading.id === '') {
                    // Generate an ID if one doesn't exist
                    heading.id = encodeURIComponent(`${index}-${heading.textContent.toLowerCase().trim().replace(/ /g, '-')}`);
                }
                const listItem = document.createElement('li');
                const anchor = document.createElement('a');

                anchor.addEventListener('click', (event) => customScrollTo(event));

                // Remove the anchor click event listener before the page unloads
                window.addEventListener('beforeunload', () => {
                    anchor.removeEventListener('click', (event) => customScrollTo(event));
                });

                anchor.href = `#${heading.id}`;
                anchor.textContent = heading.textContent;
                listItem.appendChild(anchor);
                tocList.appendChild(listItem);
            }
        });

        // Append the table of contents to the first container of #maincontent
        const mainContent = document.querySelector('#maincontent');
        if (mainContent && !onlyEmptyHeadings) {
            mainContent.prepend(container);

            window.addEventListener('scroll', listenForScroll);
            window.addEventListener('beforeunload', () => {
                window.removeEventListener('scroll', listenForScroll);
            });
        }

        // If window inner width is less than 992, the menu should be closed
        // If the window inner width is greater than or equal to 992, the menu should be open
        // It is open by default so close it if the window inner width is less than 992
        if (window.innerWidth < 992) {
            setTimeout(() => {
                toggleButton.click();
            }, 10);
        }
    }
}

document.querySelectorAll('#table-of-contents a').forEach(function (link) {
    link.addEventListener('click', function (event) {
        event.preventDefault();
        var headerText = link.textContent.trim();
        var url = window.location.href;
        _paq.push(['trackEvent', 'Innehallsförteckning', headerText, url]);
    });
});


